import request from './request'

// 管理员认证API
export const authApi = {
  // 管理员登录
  adminLogin(data) {
    return request({
      url: '/admin/login',
      method: 'post',
      data
    })
  },
  
  // 获取管理员信息
  getAdminInfo() {
    return request({
      url: '/admin/userinfo',
      method: 'get'
    })
  },

  // 修改密码
  changePassword(data) {
    return request({
      url: '/admin/change-password',
      method: 'post',
      data
    })
  },

  // 绑定微信
  bindWechat(userId, data) {
    return request({
      url: `/admin/users/${userId}/bind-wechat`,
      method: 'post',
      data
    })
  },

  // 解绑微信
  unbindWechat(userId) {
    return request({
      url: `/admin/users/${userId}/unbind-wechat`,
      method: 'delete'
    })
  },

  // 获取微信绑定状态
  getWechatBindStatus(userId) {
    return request({
      url: `/admin/users/${userId}/wechat-status`,
      method: 'get'
    })
  }
}

// 仪表板API
export const dashboardApi = {
  // 获取今日统计数据
  getTodayStats() {
    return request({
      url: '/admin/dashboard/today-stats',
      method: 'get'
    })
  },
  
  // 获取最近7天统计数据
  getWeekStats() {
    return request({
      url: '/admin/dashboard/week-stats',
      method: 'get'
    })
  },
  
  // 获取项目统计
  getProjectStats() {
    return request({
      url: '/admin/project/statistics',
      method: 'get'
    })
  }
}

// 用户管理API
export const userApi = {
  // 获取用户列表
  getUserList(params) {
    return request({
      url: '/admin/users/list',
      method: 'get',
      params
    })
  },
  
  // 审核用户
  auditUser(userId, status) {
    return request({
      url: `/admin/users/${userId}/enable`,
      method: 'put',
      data: { status }
    })
  },
  
  // 删除用户
  deleteUser(userId) {
    return request({
      url: `/admin/users/${userId}`,
      method: 'delete'
    })
  },
  
  // 获取用户人脸信息
  getUserFaceInfo(userId) {
    return request({
      url: `/face/info/${userId}`,
      method: 'get'
    })
  },
  
  // 获取用户统计
  getUserStats() {
    return request({
      url: '/admin/users/statistics',
      method: 'get'
    })
  },

  // 批量导入用户
  batchImportUsers(users) {
    return request({
      url: '/admin/users/batch-import',
      method: 'post',
      data: { users }
    })
  },

  // 新增用户
  addUser(userData) {
    return request({
      url: '/admin/users/add',
      method: 'post',
      data: userData
    })
  },

  // 批量审核用户
  batchAuditUsers(userIds, status) {
    return request({
      url: '/admin/users/batch-audit',
      method: 'put',
      data: { userIds, status }
    })
  }
}

// 考勤记录API
export const attendanceApi = {
  // 获取考勤记录列表
  getAttendanceList(data) {
    return request({
      url: '/admin/attendance/list',
      method: 'post',
      data
    })
  },
  // 获取单条考勤记录详情
  getAttendanceRecordDetail(id) {
    return request({
      url: `/admin/attendance/records/${id}`,
      method: 'get'
    })
  },
  
  // 删除考勤记录
  deleteAttendance(id) {
    return request({
      url: `/admin/attendance/${id}`,
      method: 'delete'
    })
  },
  
  // 导出考勤记录
  exportAttendanceRecords(params) {
    return request({
      url: '/admin/attendance/export',
      method: 'get',
      params,
      responseType: 'blob'
    })
  },
  
  // 获取考勤统计
  getAttendanceStats() {
    return request({
      url: '/admin/attendance/statistics',
      method: 'get'
    })
  },
  
  // 获取项目电子围栏信息
  getProjectGeofence(projectId) {
    return request({
      url: `/admin/attendance/project/${projectId}/geofence`,
      method: 'get'
    })
  }
}

// 考勤地点API
export const locationApi = {
  // 获取地点列表
  getLocationList(data) {
    return request({
      url: '/admin/locations/list',
      method: 'post',
      data
    })
  },
  
  // 添加地点
  addLocation(data) {
    return request({
      url: '/admin/locations',
      method: 'post',
      data
    })
  },
  
  // 更新地点
  updateLocation(id, data) {
    return request({
      url: `/admin/locations/${id}`,
      method: 'put',
      data
    })
  },
  
  // 删除地点
  deleteLocation(id) {
    return request({
      url: `/admin/locations/${id}`,
      method: 'delete'
    })
  }
}

// 人脸信息API
export const faceApi = {
  // 获取人脸信息列表
  getFaceList(data) {
    return request({
      url: '/admin/face-infos/list',
      method: 'post',
      data
    })
  },
  
  // 删除人脸信息
  deleteFace(id) {
    return request({
      url: `/admin/face-infos/${id}`,
      method: 'delete'
    })
  }
}

// 项目管理API
export const projectApi = {
  // 获取项目列表
  getProjectList(params) {
    return request({
      url: '/admin/project/list',
      method: 'get',
      params
    })
  },
  
  // 获取项目详情
  getProjectDetail(id) {
    return request({
      url: `/admin/project/${id}`,
      method: 'get'
    })
  },
  
  // 新增项目
  addProject(data) {
    return request({
      url: '/admin/project',
      method: 'post',
      data
    })
  },
  
  // 更新项目
  updateProject(id, data) {
    return request({
      url: `/admin/project/${id}`,
      method: 'put',
      data
    })
  },
  
  // 删除项目
  deleteProject(id) {
    return request({
      url: `/admin/project/${id}`,
      method: 'delete'
    })
  },
  
  // 获取项目成员
  getProjectMembers(id, params) {
    return request({
      url: `/admin/project/${id}/members`,
      method: 'get',
      params
    })
  },
  
  // 添加项目成员
  addProjectMember(id, data) {
    return request({
      url: `/admin/project/${id}/members`,
      method: 'post',
      data
    })
  },
  
  // 移除项目成员
  removeProjectMember(id, userId) {
    return request({
      url: `/admin/project/${id}/members/${userId}`,
      method: 'delete'
    })
  },
  
  // 批量添加项目成员
  batchAddMembers(id, data) {
    return request({
      url: `/admin/project/${id}/members/batch`,
      method: 'post',
      data
    })
  },
  
  // 更新项目状态
  updateProjectStatus(id, status) {
    return request({
      url: `/admin/project/${id}/status`,
      method: 'put',
      data: { status }
    })
  },
  
  // 获取项目统计
  getProjectStats() {
    return request({
      url: '/admin/project/statistics',
      method: 'get'
    })
  },
  
  // 获取项目选项
  getProjectOptions() {
    return request({
      url: '/admin/project/options',
      method: 'get'
    })
  },
  
  // 获取可分配用户
  getAssignableUsers(projectId) {
    return request({
      url: `/admin/project/${projectId}/available-users`,
      method: 'get'
    })
  }
}

// 考勤日历API
export const attendanceCalendarApi = {
  // 获取月度考勤日历
  getMonthlyCalendar(params) {
    return request({
      url: '/admin/attendance/calendar/monthly',
      method: 'get',
      params
    })
  },
  
  // 获取指定日期考勤详情
  getDailyDetails(params) {
    return request({
      url: '/admin/attendance/calendar/daily',
      method: 'get',
      params
    })
  },
  
  // 获取考勤异常统计
  getAbnormalStats(params) {
    return request({
      url: '/admin/attendance/calendar/abnormal-stats',
      method: 'get',
      params
    })
  },
  
  // 获取用户考勤趋势
  getUserTrend(params) {
    return request({
      url: '/admin/attendance/calendar/user-trend',
      method: 'get',
      params
    })
  },
  
  // 获取项目考勤概览
  getProjectOverview(params) {
    return request({
      url: '/admin/attendance/calendar/project-overview',
      method: 'get',
      params
    })
  },
  
  // 导出考勤日历数据
  exportCalendarData(params) {
    return request({
      url: '/admin/attendance/calendar/export',
      method: 'get',
      params,
      responseType: 'blob'
    })
  },
  
  // 获取考勤热力图
  getHeatmapData(params) {
    return request({
      url: '/admin/attendance/calendar/heatmap',
      method: 'get',
      params
    })
  }
}

// 考勤审核API
export const attendanceAuditApi = {
  // 获取待审核记录
  getPendingRecords(params) {
    return request({
      url: '/admin/attendance/audit/pending',
      method: 'get',
      params
    })
  },
  
  // 审核考勤记录
  auditRecord(id, data) {
    return request({
      url: `/admin/attendance/audit/${id}`,
      method: 'put',
      data
    })
  },
  
  // 批量审核
  batchAudit(data) {
    return request({
      url: '/admin/attendance/audit/batch',
      method: 'put',
      data
    })
  },
  
  // 修正考勤记录
  correctRecord(id, data) {
    return request({
      url: `/admin/attendance/audit/${id}/correct`,
      method: 'put',
      data
    })
  },
  
  // 获取审核历史
  getAuditHistory(params) {
    return request({
      url: '/admin/attendance/audit/history',
      method: 'get',
      params
    })
  },
  
  // 撤销审核
  revokeAudit(id, data) {
    return request({
      url: `/admin/attendance/audit/${id}/revoke`,
      method: 'put',
      data
    })
  },
  
  // 获取异常考勤记录
  getAbnormalRecords(params) {
    return request({
      url: '/admin/attendance/audit/abnormal',
      method: 'get',
      params
    })
  },
  
  // 导出审核报告
  exportAuditReport(params) {
    return request({
      url: '/admin/attendance/audit/export',
      method: 'get',
      params,
      responseType: 'blob'
    })
  }
}

// 考勤分析API
export const attendanceAnalyticsApi = {
  // 获取考勤总体统计
  getOverallStats(params) {
    return request({
      url: '/admin/attendance/analytics/overview',
      method: 'get',
      params
    })
  },
  
  // 获取考勤趋势分析
  getTrendAnalysis(params) {
    return request({
      url: '/admin/attendance/analytics/trend',
      method: 'get',
      params
    })
  },
  
  // 获取用户考勤排行
  getUserRanking(params) {
    return request({
      url: '/admin/attendance/analytics/user-ranking',
      method: 'get',
      params
    })
  },
  
  // 获取部门考勤统计
  getDepartmentStats(params) {
    return request({
      url: '/admin/attendance/analytics/department-stats',
      method: 'get',
      params
    })
  },
  
  // 获取考勤异常详细分析
  getAbnormalAnalysis(params) {
    return request({
      url: '/admin/attendance/analytics/abnormal-analysis',
      method: 'get',
      params
    })
  },
  
  // 获取考勤热力图数据
  getHeatmapData(params) {
    return request({
      url: '/admin/attendance/analytics/heatmap',
      method: 'get',
      params
    })
  },
  
  // 导出统计报告
  exportReport(params) {
    return request({
      url: '/admin/attendance/analytics/export',
      method: 'post',
      data: params,
      responseType: 'blob'
    })
  },
  
  // 获取实时考勤状态
  getRealTimeStatus() {
    return request({
      url: '/admin/attendance/analytics/realtime',
      method: 'get'
    })
  }
}

// 位置服务API
export const locationServiceApi = {
  // 逆地理编码：根据经纬度获取地址信息
  reverseGeocode(lng, lat) {
    return request({
      url: '/location/reverse-geocode',
      method: 'post',
      data: `lng=${lng}&lat=${lat}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  
  // IP定位
  getLocationByIP() {
    return request({
      url: '/location/ip',
      method: 'get'
    })
  },
  
  // 坐标转换
  convertCoordinate(lng, lat) {
    return request({
      url: '/location/convert',
      method: 'post',
      data: `lng=${lng}&lat=${lat}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }
}

// 报表管理API
export const reportApi = {
  listWeeklyReports() {
    return request({ url: '/scheduled-task/weekly-report/list', method: 'get' })
  },
  generateWeeklyReport(params) {
    return request({ url: '/scheduled-task/weekly-report/generate', method: 'post', params })
  },
  listMonthlyReports() {
    return request({ url: '/scheduled-task/monthly-report/list', method: 'get' })
  },
  generateMonthlyReport(month) {
    return request({ url: '/scheduled-task/monthly-report/generate', method: 'post', params: { month } })
  },
  listProjectReports() {
    return request({ url: '/scheduled-task/project-report/list', method: 'get' })
  },
  generateProjectReport(data) {
    return request({ url: '/scheduled-task/project-report/generate', method: 'post', params: data })
  }
}

// 系统设置相关API
export const settingsApi = {
  // 获取设置列表
  getSettingsList: (params) => request.post('/admin/system-settings/list', params),
  
  // 获取设置详情
  getSettingById: (id) => request.get(`/admin/system-settings/${id}`),
  
  // 新增设置
  addSetting: (data) => request.post('/admin/system-settings', data),
  
  // 更新设置
  updateSetting: (id, data) => request.put(`/admin/system-settings/${id}`, data),
  
  // 删除设置
  deleteSetting: (id) => request.delete(`/admin/system-settings/${id}`),
  
  // 批量删除设置
  batchDeleteSetting: (ids) => request.delete('/admin/system-settings/batch', { data: { ids } })
}

// 申述管理API（管理员）
export const appealAdminApi = {
  // 获取申述列表（支持按项目、状态筛选）
  getAppealList(params) {
    return request({
      url: '/admin/appeals',
      method: 'get',
      params
    })
  },

  // 获取申述详情
  getAppealDetail(id, params) {
    return request({
      url: `/admin/appeals/${id}`,
      method: 'get',
      params
    })
  },

  // 审核申述
  reviewAppeal(id, data) {
    return request({
      url: `/admin/appeals/${id}/review`,
      method: 'put',
      data
    })
  }
}

// 请假管理API（管理员）
export const leaveAdminApi = {
  // 获取请假列表（支持按项目、状态、日期筛选）
  getLeaveList(params) {
    return request({
      url: '/admin/leave-requests',
      method: 'get',
      params
    })
  },

  // 获取请假详情
  getLeaveDetail(id) {
    return request({
      url: `/admin/leave-requests/${id}`,
      method: 'get'
    })
  },

  // 审核请假
  reviewLeave(id, data) {
    return request({
      url: `/admin/leave-requests/${id}/review`,
      method: 'put',
      data
    })
  },

  // 批量审核请假
  batchReview(ids, data) {
    return request({
      url: '/admin/leave-requests/batch-review',
      method: 'put',
      data: { ids, ...data }
    })
  }
}

// 节假日管理API
export const holidayApi = {
  // 获取节假日列表
  getHolidayList(params) {
    return request({
      url: '/admin/holidays/list',
      method: 'get',
      params
    })
  },

  // 新增节假日
  addHoliday(data) {
    return request({
      url: '/admin/holidays',
      method: 'post',
      data
    })
  },

  // 更新节假日
  updateHoliday(id, data) {
    return request({
      url: `/admin/holidays/${id}`,
      method: 'put',
      data
    })
  },

  // 删除节假日
  deleteHoliday(id) {
    return request({
      url: `/admin/holidays/${id}`,
      method: 'delete'
    })
  }
}

// 考勤预警API
export const warningApi = {
  // 获取预警列表
  getWarningList(params) {
    return request({
      url: '/admin/warnings/list',
      method: 'get',
      params
    })
  },

  // 确认预警
  confirmWarning(id) {
    return request({
      url: `/admin/warnings/${id}/confirm`,
      method: 'put'
    })
  }
}

// 构建文件完整URL（将 /api 去掉，拼接静态资源路径）
export const buildFileUrl = (path) => {
  try {
    if (!path) return ''
    if (path.startsWith('http')) return path
    
    const base = request.defaults.baseURL || ''
    const host = base.replace(/\/api$/, '') // 获取主机地址 (例如 http://localhost:8080)
    
    // 如果已经是 /api/uploads/ 开头，说明是新路径，不需要去掉了
    // 但为了兼容性，如果 path 是 /api/uploads/xxx，而 host 是 http://xxx:8080，
    // 最终我们想要 http://xxx:8080/api/uploads/xxx (因为后端配了 /api/uploads 映射)
    // 或者 http://xxx:8080/uploads/xxx (如果后端配了 /uploads 映射)
    
    // 统一处理逻辑：
    // 1. 如果 path 是 /uploads/ 开头，自动补全为 /api/uploads/ (针对云服务器)
    let finalPath = path
    if (finalPath.startsWith('/uploads/') && !finalPath.startsWith('/api/uploads/')) {
      finalPath = '/api' + finalPath
    }
    
    // 2. 拼接 host
    // 如果 host 结尾有 /，去掉
    const cleanHost = host.endsWith('/') ? host.slice(0, -1) : host
    
    // 如果 finalPath 不是以 / 开头，补上
    if (!finalPath.startsWith('/')) {
      finalPath = '/' + finalPath
    }
    
    return cleanHost + finalPath
  } catch (e) {
    return path
  }
}